import CustomModal from '../../../../../v2-components/Antd/Modal';
import CustomButton from '../../../../../v2-components/Antd/Button';
import CustomDivider from '../../../../../v2-components/Antd/Divider';
import { dataDelete } from './handle/data-delete.handle';

export default function DeleteProductModal(props) {
	return (
		<CustomModal onCancel={() => props?.setOpenDelete(false)} footer={null} open={props?.openDelete}>
			<h2>Eliminar Producto</h2>
			<CustomDivider />
			<h3>Estas seguro de que quieres eliminar el/los siguiente/s producto/s?</h3>

			<ul>
				<li>{props?.productInfo?.name}</li>
			</ul>

			<CustomDivider />
			<div className="button-container">
				<CustomButton onClick={() => props?.setOpenDelete(false)}>Cancelar</CustomButton>
				<CustomButton onClick={() => props?.handleConfirmDelete(dataDelete(props?.productInfo))}>Confirmar</CustomButton>
			</div>
		</CustomModal>
	);
}
